/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PrivateBankingProductCatalogueResponse } from './PrivateBankingProductCatalogueResponse';
import {
    PrivateBankingProductCatalogueResponseFromJSON,
    PrivateBankingProductCatalogueResponseFromJSONTyped,
    PrivateBankingProductCatalogueResponseToJSON,
    PrivateBankingProductCatalogueResponseToJSONTyped,
} from './PrivateBankingProductCatalogueResponse';

/**
 * 
 * @export
 * @interface ProductRelation
 */
export interface ProductRelation {
    /**
     * 
     * @type {string}
     * @memberof ProductRelation
     */
    relationType?: string;
    /**
     * 
     * @type {PrivateBankingProductCatalogueResponse}
     * @memberof ProductRelation
     */
    child?: PrivateBankingProductCatalogueResponse;
}

/**
 * Check if a given object implements the ProductRelation interface.
 */
export function instanceOfProductRelation(value: object): value is ProductRelation {
    return true;
}

export function ProductRelationFromJSON(json: any): ProductRelation {
    return ProductRelationFromJSONTyped(json, false);
}

export function ProductRelationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductRelation {
    if (json == null) {
        return json;
    }
    return {
        
        'relationType': json['relationType'] == null ? undefined : json['relationType'],
        'child': json['child'] == null ? undefined : PrivateBankingProductCatalogueResponseFromJSON(json['child']),
    };
}

export function ProductRelationToJSON(json: any): ProductRelation {
    return ProductRelationToJSONTyped(json, false);
}

export function ProductRelationToJSONTyped(value?: ProductRelation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'relationType': value['relationType'],
        'child': PrivateBankingProductCatalogueResponseToJSON(value['child']),
    };
}

